"use client";

import { useMemo, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { PulseLogo } from "@/components/pulse-shell";
import { api } from "@/lib/api";
import { formatApiError } from "@/lib/users-rbac";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => params.get("token") || "", [params]);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    if (!token) {
      setError("This reset link is missing a token.");
      return;
    }
    if (password.length < 10) {
      setError("Password must be at least 10 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setBusy(true);
    try {
      await api.auth.confirmPasswordReset({ token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err, "Reset failed"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-page login-page--admin">
      <section className="login-form-side" style={{ margin: "0 auto" }}>
        <form className="login-panel" onSubmit={(e) => void submit(e)}>
          <PulseLogo dark={false} />
          <div className="eyebrow">Password reset</div>
          <h2>Choose a new password</h2>
          <p>Enter a new password for your Pulse account.</p>
          {done ? (
            <>
              <div className="users-info-banner">Password updated. You can sign in now.</div>
              <button type="button" className="login-submit" onClick={() => navigate("/login")}>
                Go to sign in
              </button>
            </>
          ) : (
            <>
              <label className="login-field">
                New password
                <div className="login-input-wrap">
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="new-password"
                    required
                  />
                </div>
              </label>
              <label className="login-field">
                Confirm password
                <div className="login-input-wrap">
                  <input
                    type="password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    autoComplete="new-password"
                    required
                  />
                </div>
              </label>
              {error && (
                <div className="login-error" role="alert">
                  {error}
                </div>
              )}
              <button className="login-submit" type="submit" disabled={busy || !token}>
                {busy ? "Updating…" : "Update password"}
              </button>
            </>
          )}
          <p className="muted" style={{ marginTop: 12, textAlign: "center" }}>
            <Link to="/login">Back to sign in</Link>
          </p>
        </form>
      </section>
    </main>
  );
}
